import _ from 'lodash';
import React from 'react';
import styled, { ThemeProvider } from 'styled-components';
import MicroProfile from '../micro-profiles/micro-profile';
import ErrorBoundary from '../../shared/error-boundary';
import defaultOnErrorHandler from '../../shared/default-on-error-handler';
import Loading from '../../shared/loading';
import useGetAll from '../../services/contributors/list-service';
import Orders from './contributors-list-components/orders';
import commonProps from './common/common-props';

const Container = styled.div`
  margin-top: 48px;

  .spinner {
    top: 48px !important;
  }
`;

const Separator = styled.div`
  height: 0px;
  border-bottom: 1px solid ${props => props.theme.primaryColor};
  margin: 16px 0 24px;
`;

const mpProps = c => ({
  key: `slug:${c.slug}:id:${c.id}`,
  profile: {
    ..._.mapKeys(c, (v, key) => _.camelCase(key)),
    canPostWires: true,
  },
  isProfileFollowedByCurrentUser: c.is_followed_by_current_user,
  isOfCurrentUser: c.is_of_current_user,
});

export default function ContributorsList() {
  const [contributors, setContributors] = React.useState([]);
  const [{ data, error, loading }, get] = useGetAll();
  const loadingRef = React.useRef();

  React.useEffect(() => {
    loadingRef.current && loadingRef.current.toggle(loading);
  }, [loading]);

  React.useEffect(() => {
    _.get(data, 'contributors') && setContributors(data.contributors);
  }, [data]);

  React.useEffect(() => {
    error && defaultOnErrorHandler(error, 'Error getting contributors');
  }, [error]);

  React.useEffect(() => {
    const order = window.location.hash.replace('#', '');
    get(order);
  }, [get]);

  const onOrderChange = order => {
    get(order);
    window.history.pushState(null, document.title, `/contributors#${order}`);
  };

  return (
    <ErrorBoundary>
      <ThemeProvider theme={commonProps()}>
        <Container>
          <Orders order={window.location.hash.replace('#', '')} onChange={onOrderChange} />
          <Separator />
          <Loading ref={loadingRef} variant="full-page">
            <section className="contributors-list">
              {contributors.map(contributor => <MicroProfile {...mpProps(contributor)} />)}
              {!contributors.length && <p>There are no contributors</p>}
            </section>
          </Loading>
        </Container>
      </ThemeProvider>
    </ErrorBoundary>
  );
}
